import React from 'react';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const DeleteIcon = ({ toolTipText = 'Delete' }) => (
  <Icon tooltip={toolTipText} iconObj={faTrashAlt} />
);

export default DeleteIcon;